var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/apps/index.tsx",
  _this = this;
import React from 'react';
import { Explore } from '../../components/navigation/Explore';
import { Manage } from '../../components/navigation/Manage';
import { Develop } from '../../components/navigation/Develop';
import { Partner } from '../../components/navigation/Partner';
import { UserMenu } from '../../components/user-menu';
var apps = {
  title: 'App Directory',
  getMenuItems: function getMenuItems() {
    return [/*#__PURE__*/React.createElement(Explore, {
      key: "menu-explore",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(Manage, {
      key: "menu-manage",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(Develop, {
      key: "menu-developer",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(Partner, {
      key: "menu-partner",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 7
      }
    })];
  },
  actions: [],
  info: [],
  user: [/*#__PURE__*/React.createElement(UserMenu, {
    key: "menu-user",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 10
    }
  })],
  homePage: '/apps/'
};
export default apps;
//# sourceMappingURL=index.js.map